import React from "react";
import { useCommonOptionalLabel } from "../../../../../common-deprecated/utils/commonLabels";
import * as Styles from "./PageFinanceDisclaimer.styles";
import Text from "../styles/atoms/Text";

type PageFinanceDisclaimerPropsType = {
    showOutline?: boolean;
};

const PageFinanceDisclaimer = ({ showOutline }: PageFinanceDisclaimerPropsType): JSX.Element | null => {
    const financeDisclaimerLabel = useCommonOptionalLabel("uscPageFinanceDisclaimer");

    if (!financeDisclaimerLabel) return null;

    return (
        <Styles.Wrapper variantOutline={showOutline}>
            <Text tag="div" variant="body-small-book" color="primary-black">
                {financeDisclaimerLabel}
            </Text>
        </Styles.Wrapper>
    );
};

export default PageFinanceDisclaimer;
